<script setup lang="ts">
import { NuxtError } from "#app";
import { AppErrorCause, isAuthError } from "@/types/AppErrorsCause";
import NovaIcon from "@/ui-kit/NovaIcon/NovaIcon.vue";
import NovaButton from "@/ui-kit/NovaButton/NovaButton.vue";
import { useAuthStore } from "@/features/auth/useAuthStore";

const { logout } = useAuthStore();

const description = computed(() => {
  switch (props.error.cause) {
    case AppErrorCause.MISSING_PERMISSION:
      return "It looks like you don't have the required permissions to view this page.";
    case AppErrorCause.JWT_TOKEN:
      return "There seems to be an issue with authentication service. Please log out and try again.";
    case AppErrorCause.SSO_PROXY:
      return "SSO_PROXY There seems to be an issue with authentication service. Please log out and try again.";
    default:
      return "Unknown error";
  }
});

const showLogout = computed(() => isAuthError(props.error.cause));

interface Props {
  error: NuxtError;
}

const props = defineProps<Props>();
</script>
<template>
  <div class="h-screen flex justify-center items-center bg-neutral-40">
    <div
      class="bg-white rounded-2xl w-[480px] min-h-[230px] flex justify-around items-center flex-col p-4 shadow-popover"
    >
      <NovaIcon name="error-solid" :size="36" />
      <p class="text-[38px] font-bold">Uh-oh...</p>
      <p class="font-bold text-center px-8">
        {{ description }}
      </p>
      <NovaButton v-if="showLogout" data-testid="app-error-logout-button" variant="text" size="sm" @click="logout">
        <NovaIcon :size="18" name="logout" class="mr-1 shrink-0" />
        <span>Log out</span>
      </NovaButton>
    </div>
  </div>
</template>
